import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
 
import { UserMemberShipData } from './account-page.data';

@Injectable({
    providedIn: 'root',
})
export class AccountPageService{
 
private profileObs$: BehaviorSubject<any> = new BehaviorSubject(null);

getProfileObs(): Observable<any> {
    return this.profileObs$.asObservable();
}

setProfileObs(profile: any) {
    this.profileObs$.next(profile);
}

// setMembershipData(userMemberShipData: Observable<UserMemberShipData>){
//     //this.userMembershipData = userMemberShipData
//     if(userMemberShipData){
//         this.profileObs$.next(userMemberShipData)
//     }
    
// }
// getMembershipData(): UserMemberShipData|any{
//     return this.userMembershipData
// }
}
